import { render, staticRenderFns } from "./_Terms.vue?vue&type=template&id=88512b88&scoped=true&"
import script from "./_Terms.vue?vue&type=script&lang=js&"
export * from "./_Terms.vue?vue&type=script&lang=js&"
import style0 from "./_Terms.vue?vue&type=style&index=0&id=88512b88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88512b88",
  null
  
)

export default component.exports